import { Map, Record, List } from 'immutable';

const struct = {
  id:              undefined,
  name:            undefined,
  key:             undefined,
  kind:            undefined,
  type:            undefined,
  suggestions:     [],
  suggestionsOnly: false,
  records:         false,
};

export default class CandidateAttribute extends Record(struct, 'CandidateAttribute') {

}
